// Функция смены позиции ТС для карты
// Выполняется после получения сообщения с новыми координатами для ТС
function teledataChanged(marker, lat, lng, speed) {

  if (marker) {
    marker.setLatLng(L.latLng(lat, lng));
  }

  if (marker && marker._icon && marker.titleFormat) {
    marker._icon.title = marker.titleFormat + ', {0} км/ч'.format(speed);
  }

  return marker;
};

// Функция реагирования на пуш Коэф-та ТС
// Выполняется после получения сообщения о завершении рассчета
function calculateTrack(workIds, reportIds) {
  if ($('#calc-track').length > 0) {
    const $control = $('#calc-track');
    $control.removeAttr('disabled');
    $control.val('Готово!').text('Рассчитать').addClass('btn-primary').removeClass('btn-danger');
    $('#date-conteiner').removeClass('busy');

      $.post('api/works/track/reports', { reportIds: reportIds })
      .done(report=> {
        report.forEach(function (coverage) {
          $('#date-conteiner > .text-left').text(coverage.CalcTime);

          if (coverage) {
              var coeff = coverage.Coverage.toFixed(0) >= 0 ? ' - ' + coverage.Coverage.toFixed(0) + '%' : '';
                $('.track')
                    .attr('class', 'track track-' + coverage.ColorName)
                    .text(coverage.Vehicle + coeff);

              var $select2 = $('.select2').select2();
              $.each($('.select2-selection__choice'), function (idx, obj) {
                var option = Select2Helper().findOption($(obj));
                var classes = option.attr("class");

                $(obj).attr("class", "select2-selection__choice " + classes);
              });
            }
        });
        return reportIds;
      });
  } else if ($('#calc-tracks').length > 0) {
    const $control = $('#calc-tracks');
      $control.val('Готово!').html('<i class="fa fa-calculator"></i> Рассчитать').removeClass('btn-danger').addClass('btn-default');
      var table = getTable();
      resetCheckedRows(table);
      updateCalculateButton(table);
    $('#WorkListItemViewModelTable_processing').attr('style', 'display:none;');

      $.post('api/works/track/reports', { reportIds: reportIds })
      .done(report=> {
        report.forEach(function (coverage) {
          $('tr', '#WorkListItemViewModelTable tbody').each(function (idxTr, tr) {
              if (Number($($(tr).children()[1]).text()) === coverage.WorkId) {
                  var coeff = coverage.Coverage.toFixed(0) >= 0 ? coverage.Coverage.toFixed(0) : 0;
                  $(tr).closest('table').find('thead').find('tr').last().find('th').each(function(idxTh, th) {
                      // Находим индекс нужной колонки
                      if ($(th).attr('aria-label').indexOf('Совпадение') > -1) {
                          $($(tr).children()[idxTh + 1]).text(coverage.CalcTime + ' - ' + coeff + '%');
                      }
                  });
              }
          });
        });
        return reportIds;
      });
  }
};

// Функция реагирования на пуш Отчета ТС по видам
function VehicleOnTypeCompelete(reportId, reInitFunc) {
  $.ajax({
    url: 'vehiclesByTypes/reloadReport/' + reportId,
    type: 'POST',
    dataType: 'html'
  }).done(function (result) {
    $('[js=vehicleOnTypeContent]').html(result);
    reInitFunc();
    $('[js=exportToExcel]').removeAttr('disabled');
    $('[js=clearFilter]').removeAttr('disabled');
    $('[js=interruptReport]').hide();
  }).fail(() => {
    $('#applyFilter').removeAttr('disabled');
    $('#VehicleOnTypeReportTable_processing').attr('style', 'display: none;');
    $('[js=exportToExcel]').removeAttr('disabled');
    $('[js=clearFilter]').removeAttr('disabled');
    $('[js=interruptReport]').hide();
  });
}

function reloadReport(reportId, tableId, reInitFunc, checkEmpty) {
    //будет сформирована таблица
    $.ajax({
        type: 'POST',
        url: Url.action('api/vehicleOnObjects/report/' + tableId),
        data: { byVehicle: $('#ByVehicle').val().toLowerCase() === 'true', checkEmpty: checkEmpty }
    }).done(function (result, status, xhr) {
        if (!checkEmpty || !result.Empty) { // Заполняем html представлением таблицы
            $('[js=vehicleOnObjContent]').html(result);
            reInitFunc();
            $('[js=exportToExcel]').removeAttr('disabled');
            $('[js=clearFilter]').removeAttr('disabled');
            $('[js=reportGroupBy]').removeAttr('disabled');
            $('[js=interruptReport]').hide();
        }
    }).fail(function (xhr, status) {
        // Убираем сообщение ожидания, разблокируем кнопку
        $('[js=applyFilter]').removeAttr('disabled');
        $('[js=clearFilter]').removeAttr('disabled');
        $('[js=exportToExcel]').removeAttr('disabled');
        $('[js=reportGroupBy]').removeAttr('disabled');
        $('[js=interruptReport]').hide();
        $('#VehicleOnObjectReportTable_processing,#VehicleOnObjectReportTableEdit_processing').attr('style', 'display: none;');

        console.error(xhr, status);
    });
}

// Функция реагирования на пуш Отчета ТС на Объ.
function VehicleOnObjectCompelete(reportId, tableId, reInitFunc) {
    reloadReport(reportId, tableId, reInitFunc, false);
}

// Функция подписки на пуш Отчетов и Коэф-та
function ReportNotificationStart(hubUrl, userId, reportIds, reInitFunc) {
  var reportHub = $.connection.reportHub;
  if (reportHub) {
    reportHub.client.reportComplete = reportId => {
      //
      if (reportIds.VehicleOnObj == reportId) {
        VehicleOnObjectCompelete(reportId, reportIds.ObjId, reInitFunc);
      }
      else if (reportIds.VehicleOnType == reportId) {
        VehicleOnTypeCompelete(reportId, reInitFunc);
      }
      else if (reportIds.CoverageReport && reportIds.CoverageReport.length > 0) {
        var workIds = reportIds.ObjId.toString().split(',');
        calculateTrack(workIds, reportIds.CoverageReport);
      }
    };

    function connectionStateChanged(state) {
      var stateConversion = { 0: 'connecting', 1: 'connected', 2: 'reconnecting', 4: 'disconnected' };

      if (state.newState === 1) {
        reportHub.server.subscribe(userId);
      }
    }

    $.connection.hub.url = hubUrl;
    $.connection.hub.stateChanged(connectionStateChanged);
    $.connection.hub.start();
    $.connection.hub.disconnected(function () {
      setTimeout(function () {
        $.connection.hub.start();
      }, 5000);
    });
  }
}
